import { useState, useEffect } from 'react'

// Shared responsive breakpoint hook for the TutorTrace dataset pages.
// Returns true when the viewport is at or below `breakpoint` (default 768px).
export default function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint}px)`
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query).matches
      : false
  )

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(query)
    const handler = (e) => setIsMobile(e.matches)
    setIsMobile(mql.matches)
    // addEventListener is the modern API; addListener is the Safari <14 fallback
    if (mql.addEventListener) mql.addEventListener('change', handler)
    else mql.addListener(handler)
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler)
      else mql.removeListener(handler)
    }
  }, [query])

  return isMobile
}
